import { GridSortItem } from '@mui/x-data-grid-pro'

import { ONE_TIME } from 'routes/outreach/outreach-message-types'

import { AllMessages, AutomatedMessagesByTrigger, PageSizeOption, Route, UIFilters } from '../types'

export type ActiveView = {
  [key in Route]?: {
    filterModel?: UIFilters
    sortModel: GridSortItem
  }
}
export type State = {
  hasError: boolean
  hasReorderError?: boolean
  errorMsg?: string
  currentPage: number
  pageSize: PageSizeOption
  isLoading: boolean
  messages?: AllMessages
  automatedMessagesByTrigger?: AutomatedMessagesByTrigger
  filteredMessages?: AllMessages
  route: Route
  activeView?: ActiveView
}

export type Action =
  | { type: 'load-messages'; messages: AllMessages; automatedMessagesByTrigger: AutomatedMessagesByTrigger }
  | { type: 'update-route'; route: Route }
  | { type: 'set-error'; hasError: boolean }
  | { type: 'set-reorder-error'; hasReorderError: boolean }
  | { type: 'update-default-view'; id: string }
  | { type: 'update-column-sort'; sortModel: GridSortItem }
  | { type: 'pageSize-change'; pageSize: PageSizeOption }
  | {
      type: 'page-change'
      page: number
    }
  | { type: 'update-filters'; filters?: UIFilters }
  | { type: 'clear-filters' }
  | { type: 'set-filtered-messages'; messages?: AllMessages }

export const initialState: State = {
  route: ONE_TIME,
  currentPage: 0,
  pageSize: 25,
  hasError: false,
  isLoading: true,
  activeView: sessionStorage.getItem('outreach-filtered-messages')
    ? (JSON.parse(sessionStorage.getItem('outreach-filtered-messages') || '{}') as ActiveView)
    : {
        'one-time': {
          sortModel: { field: 'ScheduledDate', sort: 'desc' },
        },
        automated: {
          sortModel: { field: 'Trigger', sort: 'desc' },
        },
      },
}

export default function viewsReducer(state: State = initialState, action: Action): State {
  switch (action.type) {
    case 'load-messages':
      return {
        ...state,
        messages: action.messages,
        automatedMessagesByTrigger: action.automatedMessagesByTrigger,
        isLoading: false,
        hasError: false,
      }
    case 'update-route':
      return {
        ...state,
        currentPage: 0,
        route: action.route,
      }
    case 'clear-filters':
      return {
        ...state,
        activeView: {
          ...state.activeView,
          [state.route]: {
            ...state.activeView?.[state.route],
            filterModel: {},
          },
        },
      }
    case 'update-filters':
      return {
        ...state,
        activeView: {
          ...state.activeView,
          [state.route]: {
            ...state.activeView?.[state.route],
            filterModel: {
              ...state.activeView?.[state.route]?.filterModel,
              ...action.filters,
            },
          },
        },
      }
    case 'set-filtered-messages': {
      sessionStorage.setItem('outreach-filtered-messages', JSON.stringify(state.activeView))
      return {
        ...state,
        currentPage: 0,
        filteredMessages: action.messages,
      }
    }
    case 'update-column-sort':
      return {
        ...state,
        currentPage: 0,
        activeView: {
          ...state.activeView,
          [state.route]: {
            ...state.activeView?.[state.route],
            sortModel: action.sortModel,
          },
        },
      }
    case 'pageSize-change':
      return {
        ...state,
        currentPage: 0,
        pageSize: action.pageSize,
      }
    case 'page-change':
      return {
        ...state,
        currentPage: action.page,
      }
    case 'set-error':
      return {
        ...state,
        hasError: action.hasError,
        isLoading: false,
      }
    case 'set-reorder-error':
      return {
        ...state,
        hasReorderError: action.hasReorderError,
      }

    default:
      return state
  }
}
